import { extractPageNumber } from 'src/utils/links';

export const getTranslitNameCityAndPage = (
  params: string | string[]
): {
  translitNameOfCity: string;
  pageNumber: number;
} => {
  let translitNameOfCity = '';
  let pageNumber = 1;

  const paramsArray =
    (params && (!Array.isArray(params) ? [params] : params)) || [];

  paramsArray.forEach((item) => {
    if (item.includes('page-')) {
      pageNumber = extractPageNumber(item);
      return;
    }
    translitNameOfCity = item;
  });
  return { translitNameOfCity, pageNumber };
};
